import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

const columns = [
  {
    title: '内容导航',
    links: [
      { to: '/', label: '首页' },
      { to: '/works', label: '作品合集' },
      { to: '/contestants', label: '选手盘点' },
      { to: '/about', label: '关于我们' },
    ],
  },
  {
    title: '主题分类',
    links: [
      { to: '/works?category=圈内爆料', label: '圈内爆料' },
      { to: '/works?category=深度盘点', label: '深度盘点' },
      { to: '/works?category=现场直击', label: '现场直击' },
      { to: '/works?category=幕后花絮', label: '幕后花絮' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-auto w-full bg-primary-900 text-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-fire-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-black tracking-wide text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 max-w-md font-body text-sm leading-relaxed text-primary-100">
              {siteInfo.description}
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <a
                href={`mailto:${siteInfo.cooperation}`}
                className="flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-700 px-3.5 py-2 font-label text-xs text-background-50 transition-colors hover:bg-primary-800"
              >
                <i className="ri-mail-line"></i>
                投稿与合作
              </a>
              <span className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-800/70 px-3.5 py-2 font-label text-xs text-primary-100">
                <i className="ri-mail-send-line"></i>
                {siteInfo.email}
              </span>
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">{col.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="font-label text-sm text-primary-100 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 font-label text-xs text-primary-200 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 {siteInfo.name} · {siteInfo.slogan}</p>
          <p>本站内容均标注信息来源，涉及个人信息的内容不予收录。</p>
        </div>
      </div>
    </footer>
  );
}